export default function AppLogo({ className }) {
  return (
    <img className={className} src={process.env.REACT_APP_LOGO_URL} alt={process.env.REACT_APP_LOGO_NAME + ' logo'} />
  )
}
